import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const usePriceAlert = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getAllPriceAlerts = useCallback(
    async (query) => {
      await get(`/price-alerts/?${query}`);
    },
    [get],
  );

  return { getAllPriceAlerts, data, error, loading };
};
